import {Component} from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default class Loading extends Component {
  render() {
    return (
      <CircularProgress size={60} thickness={7} />
    );
  }
}